/* =============================================================
   Cart bundle sync — removes orphan upgrade children whose
   parent line item has been removed from the cart.

   Items are linked via a line item property: _bundle_parent
   set to the parent variant ID (as string). When parent is
   gone, child line items are removed via /cart/update.js.
   ============================================================= */
(function () {
  if (window.__marbellaCartBundleSyncInit) return;
  window.__marbellaCartBundleSyncInit = true;

  var origFetch = window.fetch;
  var syncing = false;
  var debounceTimer = null;

  function syncOrphans() {
    if (syncing) return;
    syncing = true;
    origFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) { syncing = false; return; }

        var parentVariantIds = {};
        cart.items.forEach(function (i) {
          var isChild = i.properties && i.properties._bundle_parent;
          if (!isChild) parentVariantIds[String(i.variant_id)] = true;
        });

        var orphans = cart.items.filter(function (i) {
          var p = i.properties && i.properties._bundle_parent;
          return p && !parentVariantIds[String(p)];
        });

        if (orphans.length === 0) { syncing = false; return; }

        var updates = {};
        orphans.forEach(function (o) { updates[o.key] = 0; });

        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates, attributes: { _bundle_sync: '1' } })
        }).then(function () {
          syncing = false;
          // notify the theme so cart drawer / page refreshes
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // If we're on /cart, reload to repaint the page totals
          if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
            window.location.reload();
          }
        });
      })
      .catch(function () { syncing = false; });
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncOrphans, 250);
  }

  // Intercept cart-mutating fetches and trigger sync after they complete
  window.fetch = function (input, init) {
    var result = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (url && /\/cart\/(change|update|add|clear)(\.js)?/.test(url)) {
        var bodyStr = (init && init.body && typeof init.body === 'string') ? init.body : '';
        if (bodyStr.indexOf('_bundle_sync') === -1) {
          result.then(function () { scheduleSync(); }, function () {});
        }
      }
    } catch (e) {}
    return result;
  };

  // Also run on standard theme cart events (some themes don't use fetch directly)
  ['cart:refresh', 'cart:updated', 'cart:changed', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { scheduleSync(); });
  });

  // Initial sync on load (in case stale orphans exist)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOrphans);
  } else {
    syncOrphans();
  }
})();
